/* eslint-disable */
import React from 'react';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';

/**
 * This function renders the Ethics page
 * @component Ethics
 * @return {Component} Ethics component
 */
export default function Ethics() {
  return (
    <Card
      style={{
        padding: '50px',
        width: '1200px',
        margin: '30px auto 30px auto',
      }}
    >
      <div style={{borderBottom: '1px solid silver', paddingBottom: '5px'}}>
        <h1>A.I.S. Ethics & Professional Standards </h1>
      </div>
      <br />
      <p>
        The Advanced Intelligence Services Corporation works with ethic and
        skill to develop the very best biodefense information solutions
        available across the world today. The integrity of our knowledge is
        tested daily against domestic and international metabolic physics
        warfare attacks and espionage intrusion efforts, data experts use to
        improve and streamline metabolic information technology security
        protocols.
      </p>
      <p>
        Managing and promoting ethics does more than convey the professional
        courtesy we all recognize and expect. The Advanced Intelligence Services
        Corporation seeks to fortify, produce and deliver durable biodefense
        results in the context of the highest ethics and professional standards,
        as so to ensure the United States of America remains a frontrunner in
        the critical defense subjects of science and mathematics. Allow the
        Advanced Intelligence Services Corporation to maximize the biodefense
        excellence of your military organization through the integration of
        durable next generation, state-of-the-art information innovations built
        on the foundation of ethics with the long-term in mind.
      </p>
      <h2>Corporate Accountability</h2>
      <p>
        Corporate Accountability Over the next fifty years in bioscience,
        defense corporations will face greater accountability challenges in
        contexts of superior technology research and development. In 2022, the
        Advanced Intelligence Services Corporation delivers scientific
        excellence beyond brand recognition with quality information products
        and services that resolve legal and ethical liabilities of technological
        advancement, before pivotal solutions are organized for implementation.
      </p>
      <p>
        The Advanced Intelligence Services Corporation is the Defense
        Department’s premier biodefense solution provider, acknowledging
        department limitations to accept the duty of accountability, long-term.
        When DoD cannot meet the objective alone, the Advanced Intelligence
        Services Corporation is there to assure victory through information
        detail and simplicity.
      </p>
      <h2>Responsibility in Biophysics Research & Development </h2>
      <p>
        America requires the development of safe, clean biotechnologies to
        improve, fortify and maximize productivity in many daily operating
        routines. The practice of ethical, morally responsible biophysics
        research required to achieve operational success belongs to those with a
        sincere interest in cutting-edge science as well as tangifying the
        information technology challenges of the past, present and future with
        the intention of an honest resolution to the achievement of excellence,
        in and beyond the biotech industry today.
      </p>
      <h2>A.I.S. Ethics Mission Statement</h2>
      <p>
        <i>
          The Advanced Intelligence Services Corporation conducts the utmost
          ethical physics infrastructure research and development with the
          responsibility, accountability, and the highest professional standards
          required to maximize lasting professional relationships and promote
          American biodefense initiatives throughout the world, long-term.
        </i>
      </p>
      <h2>Ethics Statement From A.I.S. C.E.O. Jim Ray</h2>
      <p>
        “I find that an open discussion regarding the nature of ethics is
        essential in determining the ultimate success potential of any corporate
        culture. Professional standards define the educational and cultural
        arteries of civilization and reach into the home, impacting all kinds of
        constellations of individuals through mainstream media outlets, such as
        television, radio, the cyber- and meta-space. The presence of ethics and
        professional standards at superior levels of science and industry
        dictates the core value of our principles, and mitigates the sacrifice
        we make to ensure our great nation’s traditions of success pass to the
        next generation, and the next.” (August 01, 2022)
      </p>
    </Card>
  );
}
